var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_icon",
    transform: "translate(-375 -1362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M26,0H0V26H26Z",
    transform: "translate(375 1362)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M18.426,6.366v8.71a1.866,1.866,0,0,1-1.866,1.866H4.116A1.866,1.866,0,0,1,2.25,15.076V6.366m16.176,0A1.866,1.866,0,0,0,16.559,4.5H4.116A1.866,1.866,0,0,0,2.25,6.366m16.176,0v.2a1.867,1.867,0,0,1-.888,1.589l-6.221,3.828a1.866,1.866,0,0,1-1.958,0L3.138,8.158A1.866,1.866,0,0,1,2.25,6.569v-.2",
    transform: "translate(377.662 1364.279)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.ff1852f19469aa105b8a0aef7f288dce.svg";
export { ForwardRef as ReactComponent };